export const ModuleUser = 'user';
export const ModuleFile = 'file';
export const ModuleCategory = 'category';
export const ModuleEmployee = 'employee';
export const ModuleCustomer = 'customer';
export const ModuleOrder = 'order';
export const ModuleSupplier = 'supplier';
export const ModuleShipper = 'shipper';
export const ModuleProduct = 'product';
export const ModuleAuth = 'auth';
export const ModuleGroup = 'group';
export const ModuleUserGroup = 'usergroup';

